"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useTrackPage = void 0;
var react_1 = require("react");
var react_ga4_1 = __importDefault(require("react-ga4"));
var useTrackPage = function (_a) {
  var pathname = _a.pathname,
    _b = _a.options,
    options = _b === void 0 ? {} : _b;
  var userId = options && options.userId;
  var trackPage = function (page) {
    react_ga4_1.default.set(__assign({
      page: page
    }, options));
    react_ga4_1.default.send({
      hitType: "pageview",
      page: page
    });
  };
  (0, react_1.useEffect)(function () {
    trackPage(pathname);
  }, [pathname, userId]);
};
exports.useTrackPage = useTrackPage;